const getters = {
    itemID:state=>state.itemID,
    loading: state => state.loading
};

export default getters;